<template>
  <div>
    <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="0px"
        class="demo-ruleForm flex-dir-center"
    >
      <el-form-item prop="telephone">
        <el-input v-model="ruleForm.telephone" placeholder="请输入手机号码" :readonly="readonly" @focus="handleFocus"
                  @blur="handleBlur">
          <i slot="prefix" class="el-input__icon el-icon-user-solid"></i>
        </el-input>
      </el-form-item>
      <el-form-item class="captcha-item" prop="captcha">
        <el-input v-model="ruleForm.captcha" placeholder="请输入短信验证码" :readonly="readonly" @focus="handleFocus"
                  @blur="handleBlur">
          <i slot="prefix" class="el-input__icon el-icon-s-opportunity"></i>
        </el-input>
        <div v-if="!hadSend" class="get-cap" @click="getCaptcha">获取验证码</div>
        <div v-if="hadSend" class="get-cap">{{ count }}s重新获取</div>
      </el-form-item>
      <el-form-item prop="newPassword">
        <el-input show-password auto-complete="new-password" v-model="ruleForm.newPassword" placeholder="请输入密码">
          <i slot="prefix" class="el-input__icon el-icon-lock"></i>
        </el-input>
      </el-form-item>
      <el-form-item prop="conformPassword">
        <el-input show-password v-model="ruleForm.conformPassword" placeholder="请再次输入新密码">
          <i slot="prefix" class="el-input__icon el-icon-lock"></i>
        </el-input>
      </el-form-item>
      <el-form-item>
        <el-button class="next-button" type="primary" @click="submitForm('ruleForm')">确定</el-button>
      </el-form-item>
    </el-form>
    <verify-code ref="verifyRef" @getMessage="getMessage"></verify-code>
  </div>
</template>
<script>
import verifyCode from "@/components/VerifyCode.vue";

export default {
  components: {verifyCode},
  props: {
    verifyId: {
      type: String,
      default: ''
    }
  },
  data() {
    var validNewPass = (rule, value, callback) => {
      let reg = /(?!^(\d+|[A-Z]+|[a-z]+|[~!@#$%^&*?]+)$)^[\w~!@#$%^&*?]{8,16}$/;
      if (value === "") {
        callback(new Error("请输入新密码"));
      } else if (!reg.test(value)) {
        callback(
            new Error(
                "密码长度为8-16位;必须包含大写字母、小写字母、数字和特殊字符中的两种或以上"
            )
        );
      } else {
        if (this.ruleForm.confirmPassword !== "") {
          this.$refs.ruleForm.validateField("confirmPassword");
        }
        callback();
      }
    };
    var validatePass2 = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请再次输入密码"));
      } else if (value !== this.ruleForm.newPassword) {
        callback(new Error("两次输入密码不一致!"));
      } else {
        callback();
      }
    };
    var validPhone = (rule, value, callback) => {
      let reg = /^1[3456789]\d{9}$/;
      if (value === "") {
        callback(new Error("请输入实名手机号码"));
      } else if (!reg.test(value)) {
        callback(new Error("请输入实名手机号码"));
      } else {
        callback();
      }
    };
    return {
      ruleForm: {
        telephone: undefined,
        captcha: undefined
      },
      rules: {
        newPassword: [{validator: validNewPass, trigger: "blur"}],
        conformPassword: [{validator: validatePass2, trigger: "blur"}],
        telephone: [{required: true, validator: validPhone, trigger: "blur"}],
        captcha: [
          {required: true, message: "请输入短信验证码", trigger: "blur"}
        ]
      },
      hadSend: false,
      count: 60,
      timer: null,
      readonly: true
    };
  },
  methods: {
    handleFocus() {
      this.readonly = false
    },
    handleBlur() {
      this.readonly = true
    },
    getCaptcha() {
      if (!this.ruleForm.telephone) {
        this.$message.warning("请先输入手机号码");
        return;
      }
      this.$refs.verifyRef.show(this.ruleForm.telephone);
    },
    getMessage(param) {
      let params = param;
      params.telephone = this.ruleForm.telephone;
      this.loading = true;
      this.$http.post(this.$api.register.sendSMSCode, params).then((res) => {
        this.loading = false;
        if (res.data.code == 200) {
          this.$message.success(res.data.msg);
          this.hadSend = true;
          this.count = 60;
          this.timer = setInterval(() => {
            if (this.count > 1) {
              this.count--;
            } else {
              if (this.timer) {
                this.hadSend = false;
                clearInterval(this.timer);
              }
            }
          }, 1000);
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    submitForm() {
      this.$refs.ruleForm.validate(async value => {
        if (value) {
          this.$http.post(this.$api.customerEnterprise.changeKqPassword, {
            smsCode: this.ruleForm.captcha,
            telephone: this.ruleForm.telephone,
            newPassword: this.ruleForm.newPassword
          }).then(res => {
            if (res.data.code == 200) {
              // this.$auth.setToken(res.data.data.token)
              // this.$emit('update:verifyId', res.data.data.verifyId);
              this.$emit("changeActive", 2);
            } else {
              this.$message.error(res.data.msg);
            }
          });
        }
      });
    }
  }
};
</script>
<style lang="less" scoped>
.captcha-item {
  position: relative;
}

.get-cap {
  position: absolute;
  right: 20px;
  top: 0;
  color: #407fff;
  cursor: pointer;
}

.next-button {
  width: 370px;
  height: 42px;
  margin-top: 20px;
  font-size: 16px;
  box-shadow: 0 2px 4px 0 rgba(64, 129, 255, 0.4);
}

::v-deep .el-input--prefix .el-input__inner {
  width: 370px;
}
</style>
